import { WalletTypeEnum } from '@/context/types/Wallet';
import { EnumValues } from '@/services/types/EnumValues';

type TWalletType = EnumValues<typeof WalletTypeEnum>;

export const getWalletTypeDisplay = (walletType: TWalletType | undefined): string => {
  if (!walletType) return '';
  return walletType
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};
